<template>
    <el-drawer v-model="localVisible" title="更新内容" :with-header="false" :size="drawerSize" :before-close="handleClose"
        class="update-drawer" :class="{ 'is-mobile': isMobile }">
        
        <!-- 自定义头部 -->
        <div class="drawer-header">
            <div class="header-kicker">VEHICLE DATA CHANGELOG</div>
            <h3 class="header-title">更新日志</h3>
            <div class="header-metrics">
                <span>{{ sortedActivities.length }} 条记录</span>
                <span>Latest {{ sortedActivities[0]?.timestamp }}</span>
            </div>
        </div>

        <!-- 移动端卡片式时间轴 -->
        <div v-if="isMobile" class="mobile-timeline">
            <div v-for="(activity, index) in sortedActivities" :key="index" class="timeline-card">
                <div class="card-header">
                    <span class="card-date">{{ activity.timestamp }}</span>
                    <el-tag :type="getTagType(activity.color)" size="small" effect="light" class="card-tag">
                        {{ getTagText(activity.color) }}
                    </el-tag>
                </div>
                <div class="card-content">
                    <p class="card-text">{{ activity.content }}</p>
                </div>
            </div>
        </div>

        <!-- 桌面端时间轴 -->
        <el-timeline v-else>
            <el-timeline-item v-for="(activity, index) in sortedActivities" :key="index" :icon="activity.icon"
                :type="activity.type" :color="activity.color" :size="activity.size" :hollow="activity.hollow"
                :timestamp="activity.timestamp">
                {{ activity.content }}
            </el-timeline-item>
        </el-timeline>
    </el-drawer>
</template>

<script>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import { MoreFilled } from '@element-plus/icons-vue'

export default {
    props: {
        modelValue: {
            type: Boolean
        }
    },
    setup(props, { emit }) {
        const activities = ref([
            {
                content: '初步建站,实现国内,海外在线诊断日志查询',
                timestamp: '2024-09-21',
                size: 'large',
                type: 'primary',
                icon: MoreFilled,
            },
            {
                content: 'new:测试接头查询,添加,删除功能',
                timestamp: '2024-09-25',
                color: '#0bbd87',
            },
            {
                content: 'new:黑名单接头查询,添加,删除功能',
                timestamp: '2024-09-27',
                color: '#0bbd87',
            },
            {
                content: 'bug:修复登录认证',
                timestamp: '2024-10-08',
                color: '#ff0000',
            },
            {
                content: 'new:外码查询,下载外码文件功能',
                timestamp: '2024-10-08',
                color: '#0bbd87',
            },
            {
                content: 'update:日志查询输入框添加3行历史纪录',
                timestamp: '2024-10-10',
                color: '#f89898',
            },
            {
                content: 'new:在线接口类型解析',
                timestamp: '2024-10-10',
                color: '#0bbd87',
            },
            {
                content: 'change:修改测试接头菜单过滤查找为SN',
                timestamp: '2024-10-16',
                color: '#E6A23C',
            },
            {
                content: 'bug:修复使用过程中,token失效未返回登录页面',
                timestamp: '2024-10-17',
                color: '#ff0000',
            },
            {
                content: 'new:VIN数据下载情况展示',
                timestamp: '2024-10-17',
                color: '#0bbd87',
            },
            {
                content: 'new:服务器中存在访问记录的VIN,提供爬取Request按钮(工作期间开放爬取)',
                timestamp: '2024-10-21',
                color: '#0bbd87',
            },
            {
                content: 'new:服务器中存在访问记录的VIN,提供下载VM文件按钮(状态为OK即可下载)',
                timestamp: '2024-10-22',
                color: '#0bbd87',
            },
            {
                content: 'bug:修复黑名单接头查询不全的问题',
                timestamp: '2024-10-30',
                color: '#ff0000',
            },
            {
                content: 'update:日志查询添加Vin参数',
                timestamp: '2024-12-09',
                color: '#f89898',
            },
            {
                content: 'change:黑名单接头删除后,清空该接头累计数据',
                timestamp: '2024-12-09',
                color: '#E6A23C',
            },
            {
                content: 'update:添加黑名单接头时,支持填写封号原因',
                timestamp: '2024-12-12',
                color: '#f89898',
            },
            {
                content: 'update:VIN数据一栏显示账号登录状态',
                timestamp: '2024-12-16',
                color: '#f89898',
            },   
            {
                content: 'update:VIN数据一栏搜索时显示模板，并提供PC调试用的加密文件下载',
                timestamp: '2024-12-18',
                color: '#f89898',
            },   
            {
                content: 'new:数据转存公司服务器,分为打包,下载,标记上传三部分.(操作权限仅开放给维护人员)',
                timestamp: '2024-12-24',
                color: '#0bbd87',
            },   
            {
                content: 'new:根据VIN前11位查询防盗快捷版模式.(操作权限仅开放给开发人员) by:LYJ',
                timestamp: '2024-12-26',
                color: '#0bbd87',
            },   
            {
                content: 'update:测试接头菜单添加仅模板测试按钮',
                timestamp: '2025-01-16',
                color: '#f89898',
            },   
            {
                content: 'new:新增在线诊断日志查询设置,可屏蔽列属性或调整列宽',
                timestamp: '2025-02-10',
                color: '#0bbd87',
            },   
            {
                content: 'new:更换头像,修改用户名称和密码等',
                timestamp: '2025-02-12',
                color: '#0bbd87',
            },
            {
                content: 'new:福特安全校验日志,GGP日期调整,马自达账号修改',
                timestamp: '2025-02-25',
                color: '#0bbd87',
            },
            {
                content: 'new:在线so版本控制',
                timestamp: '2025-03-10',
                color: '#0bbd87',
            },
            {
                content: 'new:马自达综合菜单,由马自达开发维护前后端',
                timestamp: '2025-08-14',
                color: '#0bbd87',
            },
            {
                content: 'new:新增上传TRID数据上传功能',
                timestamp: '2025-08-30',
                color: '#0bbd87',
            },
            {
                content: 'new:开放接口文档入口',
                timestamp: '2026-01-21',
                color: '#0bbd87',
            },
            {
                content: '支持手机端界面自适应',
                timestamp: '2026-02-26',
                color: '#f89898',
            }
        ]);

        // 响应式判断手机端
        const isMobile = ref(window.innerWidth <= 768);
        
        const handleResize = () => {
            isMobile.value = window.innerWidth <= 768;
        };

        onMounted(() => {
            window.addEventListener('resize', handleResize);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });

        // 根据屏幕尺寸动态设置抽屉宽度
        const drawerSize = computed(() => {
            return isMobile.value ? '90%' : '30%';
        });

        // 本地响应式变量来控制抽屉的显示状态  
        const localVisible = ref(props.modelValue);

        // 监听 props.visible 的变化，并更新 localVisible  
        watch(() => props.modelValue, (newValue) => {
            localVisible.value = newValue;
        });

        // 处理抽屉关闭事件  
        const handleClose = (done) => {
            emit('update:modelValue', false);
            done();
        };

        // 根据颜色值获取标签类型
        const getTagType = (color) => {
            const colorMap = {
                '#0bbd87': 'success',
                '#ff0000': 'danger',
                '#f89898': 'warning',
                '#E6A23C': 'warning',
            };
            return colorMap[color] || 'info';
        };

        // 根据颜色值获取标签文本
        const getTagText = (color) => {
            const textMap = {
                '#0bbd87': '新增',
                '#ff0000': '修复',
                '#f89898': '更新',
                '#E6A23C': '变更',
            };
            return textMap[color] || '其他';
        };

        // 计算属性：将活动按时间倒序排列（最新的在前）
        const sortedActivities = computed(() => {
            return [...activities.value].sort((a, b) => {
                // 将时间字符串转换为Date对象进行比较
                const dateA = new Date(a.timestamp);
                const dateB = new Date(b.timestamp);
                return dateB - dateA; // 降序排列（最新的在前）
            });
        });

        return {
            localVisible,
            handleClose,
            MoreFilled,
            activities,
            sortedActivities, // 使用排序后的数据
            isMobile,
            drawerSize,
            getTagType,
            getTagText
        };
    }
};
</script>

<style scoped>
/* 基础样式 */
.drawer-header {
    position: relative;
    overflow: hidden;
    padding: 26px 22px 18px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.2);
    background:
        linear-gradient(135deg, #0f172a 0%, #1e293b 52%, #0f766e 100%);
    color: #ffffff;
    margin-bottom: 16px;
}

.drawer-header::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
        linear-gradient(90deg, rgba(255, 255, 255, 0.08) 1px, transparent 1px),
        linear-gradient(180deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
    background-size: 22px 22px;
    opacity: 0.35;
}

.drawer-header::after {
    content: "";
    position: absolute;
    right: -44px;
    bottom: -46px;
    width: 150px;
    height: 150px;
    border: 1px solid rgba(45, 212, 191, 0.32);
    border-radius: 50%;
}

.header-kicker,
.header-title,
.header-metrics {
    position: relative;
    z-index: 1;
}

.header-kicker {
    color: rgba(203, 213, 225, 0.78);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
}

.header-title {
    margin: 8px 0 12px;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0;
}

.header-metrics {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.header-metrics span {
    display: inline-flex;
    align-items: center;
    min-height: 26px;
    padding: 4px 10px;
    border: 1px solid rgba(203, 213, 225, 0.22);
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.28);
    color: rgba(255, 255, 255, 0.84);
    font-size: 12px;
    box-sizing: border-box;
}

/* 桌面端时间轴样式 */
:deep(.el-timeline) {
    padding: 0 20px 20px;
}

:deep(.el-timeline-item__content) {
    font-size: 14px;
    line-height: 1.6;
    color: #334155;
    background-color: #ffffff;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.04);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

:deep(.el-timeline-item__content:hover) {
    transform: translateX(3px);
    box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
}

:deep(.el-timeline-item__timestamp) {
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
}

/* ========== 移动端样式 ========== */
@media screen and (max-width: 768px) {
    .update-drawer.is-mobile {
        /* 确保抽屉内容可以滚动 */
        :deep(.el-drawer__body) {
            padding: 0;
            overflow-y: auto;
            background-color: #f5f7fa;
        }
    }

    /* 移动端头部 */
    .drawer-header {
        padding: 20px 16px;
        margin-bottom: 0;
        border-radius: 0;
    }

    .header-title {
        font-size: 18px;
    }

    .header-subtitle {
        font-size: 12px;
    }

    /* 移动端卡片式时间轴 */
    .mobile-timeline {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .timeline-card {
        background: #ffffff;
        border-radius: 16px;
        padding: 16px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
        border: 1px solid #f0f2f5;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .timeline-card:active {
        transform: scale(0.99);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px dashed #e9ecef;
    }

    .card-date {
        font-size: 14px;
        font-weight: 500;
        color: #409eff;
        background-color: #ecf5ff;
        padding: 4px 10px;
        border-radius: 20px;
    }

    .card-tag {
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 12px;
        font-weight: 500;
    }

    .card-content {
        padding: 0 2px;
    }

    .card-text {
        margin: 0;
        font-size: 14px;
        line-height: 1.6;
        color: #303133;
        word-break: break-word;
    }

    /* 不同类型卡片的微渐变背景（可选） */
    .timeline-card {
        background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
    }
}

/* 桌面端隐藏移动端元素 */
@media screen and (min-width: 769px) {
    .mobile-timeline {
        display: none;
    }
}

/* 滚动条美化 */
:deep(.el-drawer__body)::-webkit-scrollbar {
    width: 6px;
}

:deep(.el-drawer__body)::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;
}

:deep(.el-drawer__body)::-webkit-scrollbar-track {
    background: #f5f7fa;
}
</style>
